import { ADD_ITEM_OPTION } from "../Actions/Utilites";


const INITIAL_STATE = {
    // Add Menu
    addItemOptionLoading: false,
    addItemOptionSuccess: false,
    addItemOptionFailure: false,
    addItemOptionError: [],

    // Get All ITEM OPTION
    getAllItemOption: [],

    //   Delete Menu
    deleteItemOptionLoading: false,
    deleteItemOptionSuccess: false,
    deleteItemOptionFailure: false,
    deleteItemOptionError: null,
    deleteMenu: [],
}

export const ItemOptionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_ITEM_OPTION.ADD_ITEM_OPTION_REQUEST:
            return {
                ...state,
                addItemOptionLoading: true,
                addItemOptionSuccess: false,
                addItemOptionFailure: false,
                addItemOptionError: null,
            };
        case ADD_ITEM_OPTION.ADD_ITEM_OPTION_SUCCESS:
            return {
                ...state,
                addItemOptionLoading: false,
                addItemOptionSuccess: true,
                addItemOptionFailure: false,
                addItemOptionError: null,
                getAllItemOption: [...state.getAllItemOption, action.payload],
            };
        case ADD_ITEM_OPTION.ADD_ITEM_OPTION_FAILURE:
            return {
                ...state,
                addItemOptionLoading: false,
                addItemOptionSuccess: false,
                addItemOptionFailure: true,
                addItemOptionError: action.payload,
            };
        case ADD_ITEM_OPTION.SET_NULL_MENU_ITEM_OPTION_LIST:
            return {
                ...state,
                addItemOptionLoading: false,
                addItemOptionSuccess: true,
                addItemOptionFailure: false,
                addItemOptionError: null,
                getAllItemOption: action.payload,
            };

        // Delete Note

        case ADD_ITEM_OPTION.DELETE_ITEM_OPTION_REQUEST:
            return {
                ...state,
                deleteItemOptionLoading: true,
                deleteItemOptionSuccess: false,
                deleteItemOptionFailure: false,
                deleteItemOptionError: null,
            };
        case ADD_ITEM_OPTION.DELETE_ITEM_OPTION_SUCCESS:
            debugger;
            const result = state.getAllItemOption.filter(
                (note) => note.itemOptionId !== action.payload.result
            );
            return {
                ...state,
                deleteItemOptionLoading: false,
                deleteItemOptionSuccess: true,
                deleteItemOptionFailure: false,
                deleteItemOptionError: null,
                getAllItemOption: result,
            };
        case ADD_ITEM_OPTION.DELETE_ITEM_OPTION_FAILURE:
            return {
                ...state,
                deleteItemOptionLoading: false,
                deleteItemOptionSuccess: false,
                deleteItemOptionFailure: true,
                deleteItemOptionError: action.payload,
            };

        default:
            return state;
    }
}